export function rxsecret () {
  let result = []
  result.web_port = 3388
  // result.base_api = 'https://dev.api.netalo.vn'
  // result.socket_api = 'https://dev.conn1.netalo.vn'
  // result.profile_api = 'https://dev.ss1.netalo.vn'
  result.base_api = 'https://api.netalo.vn'
  result.socket_api = 'https://conn1.netalo.vn'
  result.profile_api = 'https://ss1.netalo.vn'
  result.cdn_endpoint =  'https://sxlkrvlcuqweb.vcdn.cloud/profiles/'

  result.application_id = 10
  result.auth_key = 'PS2zTS5$VyZccSaj'
  result.nonce = 38735
  result.signature = '40d579ce5b7a83495fe12e19d52ef32e31d42494'
  result.timestamp = 1605891407
  
  result.theme = 'galo'
  return result
}
